import styled from 'styled-components';
import _FirstHeatSvg from '@/assets/icons/first_heat.svg?react';
import { ButtonWithIcon } from '@/components/IconButton';

const Container = styled(ButtonWithIcon)`
    color: var(--Neutral-800, #27272a);
    background: var(--Neutral-Opacity-200, rgba(228, 228, 231, 0.5)) !important;

    &[aria-selected='true'] {
        background-color: #ffcf00 !important;
    }

    svg {
        width: 1.5rem;
        height: 1.5rem;
        color: #27272a;
    }
`;

export const FirstHeatSvg = _FirstHeatSvg;

export const FirstHeatToggle = ({
    isFirstHeat,
    setFirstHeat,
    shouldHideText
}: {
    isFirstHeat: boolean;
    setFirstHeat: (d: (d: boolean) => boolean) => void;
    shouldHideText?: boolean
}) => {
    return (
        <Container
            variant={['yellow', 'round']}
            aria-selected={isFirstHeat}
            onClick={() => setFirstHeat(e => !e)}
            className='first-heat'
        >
            <FirstHeatSvg />
            {!shouldHideText && "FirstHeat"}
        </Container>
    );
};
